import { Header } from "@/components/Header";
import { Footer } from "@/components/Footer";
import { SEOHead } from "@/components/SEOHead";

const Terms = () => {
  return (
    <div className="min-h-screen bg-white font-sans text-foreground flex flex-col">
      <SEOHead
        title="Terms & Conditions | Clean Marketing"
        description="The terms and conditions for using Clean Marketing's digital marketing, automated booking, and CRM services for window cleaning businesses."
        canonical="/terms"
      />
      <Header />
      <main className="flex-grow container mx-auto px-4 py-16 max-w-3xl">
        <h1 className="text-4xl font-bold text-secondary mb-8">
          Terms & Conditions
        </h1>
        <div className="space-y-6 text-slate-600 leading-relaxed">
          <p>Last updated: {new Date().toLocaleDateString()}</p>

          <h2 className="text-2xl font-semibold text-secondary mt-8 mb-4">
            1. Introduction
          </h2>
          <p>
            Welcome to Clean Marketing. By accessing our website and using our
            services, you agree to be bound by these Terms & Conditions. Please
            read them carefully.
          </p>

          <h2 className="text-2xl font-semibold text-secondary mt-8 mb-4">
            2. Services
          </h2>
          <p>
            Clean Marketing provides digital marketing, automated booking
            systems, and CRM solutions specifically designed for window cleaning
            businesses. We reserve the right to modify, suspend, or discontinue
            any part of the service at any time.
          </p>

          <h2 className="text-2xl font-semibold text-secondary mt-8 mb-4">
            3. Exclusive Territories
          </h2>
          <p>
            We operate on an exclusive territory basis, working with only one
            window cleaning company per designated town or area. This
            exclusivity is maintained as long as your account remains active and
            in good standing.
          </p>

          <h2 className="text-2xl font-semibold text-secondary mt-8 mb-4">
            4. Payment Terms
          </h2>
          <p>
            Services are billed on a monthly subscription basis, plus any
            applicable one-time setup fees. All fees are exclusive of VAT unless
            otherwise stated. Failure to pay may result in suspension of
            services and loss of territory exclusivity.
          </p>

          <h2 className="text-2xl font-semibold text-secondary mt-8 mb-4">
            5. Limitation of Liability
          </h2>
          <p>
            Clean Marketing shall not be liable for any indirect, incidental,
            special, consequential or punitive damages, including without
            limitation, loss of profits, data, use, goodwill, or other
            intangible losses, resulting from your access to or use of or
            inability to access or use the services.
          </p>
        </div>
      </main>
      <Footer />
    </div>
  );
};

export default Terms;
